var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"LeftCenter"}},[_c('dv-border-box-13',[_c('HeaderTitle',{attrs:{"title":"本月订单"}}),_c('LeftCenterEarch')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }